export class SuperscriptRefHelper {
    static superscriptRefs: Map<string, string> = new Map();
    static footnoteRefs: Map<string, () => void> = new Map();
    static registerFootnote(footnoteId: string, callback: () => void) {
        if (footnoteId) {
            this.footnoteRefs.set(footnoteId, callback);
        }
    }
    static assignRef(superscriptId: string, ref: string) {
        SuperscriptRefHelper.superscriptRefs.set(superscriptId, ref);
    }
    static focusFootnote(superscriptId: string) {
        const footnoteCallback = this.footnoteRefs.get(superscriptId);
        if (footnoteCallback) {
            footnoteCallback();
        }
    }
    static hasRef(superscriptId: string) {
        return SuperscriptRefHelper.superscriptRefs.has(superscriptId);
    }
    static getRef(superscriptId: string) {
        return SuperscriptRefHelper.superscriptRefs.get(superscriptId);
    }
    static removeRef(superscriptId: string) {
        return SuperscriptRefHelper.superscriptRefs.delete(superscriptId);
    }
    static removeRefWhere(superscriptId: string, ref: string) {
        const storedRef = SuperscriptRefHelper.superscriptRefs.get(
            superscriptId
        );
        if (storedRef === ref) {
            return SuperscriptRefHelper.superscriptRefs.delete(superscriptId);
        }
        return true;
    }
}



// WEBPACK FOOTER //
// ./src/utils/SuperscriptRefHelper.ts